<template>
  <el-dialog
    title="人员权限详情"
    :visible.sync="visible"
    label-width="100px"
    width="500px"
    @close="$emit('update:show', false)"
  >
    <el-form label-width="90px" label-position="left" size="small">
      <el-form-item label="拥有角色：">
        <div class="el-input">{{ showRoles(user.auth_roles) }}</div>
      </el-form-item>
      <el-form-item label="拥有权限：">
        <el-tree
          ref="tree"
          :data="auths"
          :props="defaultProps"
          node-key="code"
          class="permission-tree"
        />
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { authList, userDetail } from '@/service/getData'

export default {
  props: {
    userId: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: this.show,
      auths: [],
      user: {},
      defaultProps: {
        children: 'children',
        label: 'name',
      },
    }
  },

  watch: {
    show() {
      this.visible = this.show
      if (this.visible && this.userId) {
        this.getUserDetail()
      }
    },
  },

  methods: {
    async getUserDetail() {
      let res = await userDetail(this.userId)
      this.user = res.data
      this.getAuths()
    },
    showRoles(roles) {
      if (!roles) return ''
      let names = roles.map((item) => {
        return item.name
      })
      return names.join(' / ')
    },

    filterTree(tree = [], arr1 = [], arr2 = []) {
      if (!tree.length) return []
      for (let item of tree) {
        let node = { ...item, children: [] }
        if (item.codes[0]) {
          node.code = item.codes[0]
          if (
            this.user.auth_codes.includes(node.code) ||
            this.user.is_super_admin
          ) {
            arr1.push(node)
          }
        }

        let node1 = { ...item, children: [] }
        if (item.codes[1]) {
          node1.code = item.codes[1]
          if (
            this.user.auth_codes.includes(node1.code) ||
            this.user.is_super_admin
          ) {
            arr2.push(node1)
          }
        }

        if (item.children && item.children.length)
          this.filterTree(item.children, node.children, node1.children)
      }
      return [arr1, arr2]
    },

    async getAuths() {
      let res = await authList()
      if (res.code == 0) {
        let auths = this.filterTree(res.data.list)
        this.auths = auths[0]
        // this.auths = [
        //   { name: 'PC端', code: '100000', children: auths[0] },
        //   { name: '移动端', code: '200000', children: auths[1] },
        // ]
      }
    },
  },
}
</script>
<style scoped>
.permission-tree {
  background: none;
  left: -9px;
  margin-top: 5px;
}
</style>